// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPaymentAddressRequestDto } from './IPaymentAddressRequestDto';
import {
    IPaymentAddressRequestDtoFromJSON,
    IPaymentAddressRequestDtoFromJSONTyped,
    IPaymentAddressRequestDtoToJSON,
    IPaymentAddressRequestDtoToJSONTyped,
} from './IPaymentAddressRequestDto';

/**
 * 
 * @export
 * @interface IUpdatePaymentMethodRequestDto
 */
export interface IUpdatePaymentMethodRequestDto {
    /**
     * 
     * @type {IPaymentAddressRequestDto}
     * @memberof IUpdatePaymentMethodRequestDto
     */
    address?: IPaymentAddressRequestDto;
    /**
     * 
     * @type {string}
     * @memberof IUpdatePaymentMethodRequestDto
     */
    phone_number?: string;
    /**
     * 
     * @type {string}
     * @memberof IUpdatePaymentMethodRequestDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof IUpdatePaymentMethodRequestDto
     */
    card_holder_name?: string;
    /**
     * 
     * @type {Date}
     * @memberof IUpdatePaymentMethodRequestDto
     */
    card_expiration_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IUpdatePaymentMethodRequestDto
     */
    card_last4?: string;
    /**
     * 
     * @type {string}
     * @memberof IUpdatePaymentMethodRequestDto
     */
    card_token?: string;
    /**
     * 
     * @type {string}
     * @memberof IUpdatePaymentMethodRequestDto
     */
    card_type?: IUpdatePaymentMethodRequestDtoCardTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IUpdatePaymentMethodRequestDto
     */
    account_description?: string;
    /**
     * 
     * @type {string}
     * @memberof IUpdatePaymentMethodRequestDto
     */
    account_number?: string;
    /**
     * 
     * @type {string}
     * @memberof IUpdatePaymentMethodRequestDto
     */
    account_routing_transit_number?: string;
    /**
     * 
     * @type {string}
     * @memberof IUpdatePaymentMethodRequestDto
     */
    account_category?: IUpdatePaymentMethodRequestDtoAccountCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof IUpdatePaymentMethodRequestDto
     */
    account_number_last4?: string;
    /**
     * 
     * @type {number}
     * @memberof IUpdatePaymentMethodRequestDto
     */
    account_number_length?: number;
    /**
     * 
     * @type {number}
     * @memberof IUpdatePaymentMethodRequestDto
     */
    account_id?: number;
}

/**
* @export
* @enum {string}
*/
export enum IUpdatePaymentMethodRequestDtoCardTypeEnum {
    AMEX = 'AMEX',
    VISA = 'VISA',
    MASTERCARD = 'MASTERCARD'
}
/**
* @export
* @enum {string}
*/
export enum IUpdatePaymentMethodRequestDtoAccountCategoryEnum {
    CHECKING = 'CHECKING',
    SAVING = 'SAVING',
    NONE = 'NONE'
}


/**
 * Check if a given object implements the IUpdatePaymentMethodRequestDto interface.
 */
export function instanceOfIUpdatePaymentMethodRequestDto(value: object): value is IUpdatePaymentMethodRequestDto {
    return true;
}

export function IUpdatePaymentMethodRequestDtoFromJSON(json: any): IUpdatePaymentMethodRequestDto {
    return IUpdatePaymentMethodRequestDtoFromJSONTyped(json, false);
}

export function IUpdatePaymentMethodRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IUpdatePaymentMethodRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'address': json['address'] == null ? undefined : IPaymentAddressRequestDtoFromJSON(json['address']),
        'phone_number': json['phone_number'] == null ? undefined : json['phone_number'],
        'email': json['email'] == null ? undefined : json['email'],
        'card_holder_name': json['card_holder_name'] == null ? undefined : json['card_holder_name'],
        'card_expiration_date': json['card_expiration_date'] == null ? undefined : (new Date(json['card_expiration_date'])),
        'card_last4': json['card_last4'] == null ? undefined : json['card_last4'],
        'card_token': json['card_token'] == null ? undefined : json['card_token'],
        'card_type': json['card_type'] == null ? undefined : json['card_type'],
        'account_description': json['account_description'] == null ? undefined : json['account_description'],
        'account_number': json['account_number'] == null ? undefined : json['account_number'],
        'account_routing_transit_number': json['account_routing_transit_number'] == null ? undefined : json['account_routing_transit_number'],
        'account_category': json['account_category'] == null ? undefined : json['account_category'],
        'account_number_last4': json['account_number_last4'] == null ? undefined : json['account_number_last4'],
        'account_number_length': json['account_number_length'] == null ? undefined : json['account_number_length'],
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
    };
}

export function IUpdatePaymentMethodRequestDtoToJSON(json: any): IUpdatePaymentMethodRequestDto {
    return IUpdatePaymentMethodRequestDtoToJSONTyped(json, false);
}

export function IUpdatePaymentMethodRequestDtoToJSONTyped(value?: IUpdatePaymentMethodRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'address': IPaymentAddressRequestDtoToJSON(value['address']),
        'phone_number': value['phone_number'],
        'email': value['email'],
        'card_holder_name': value['card_holder_name'],
        'card_expiration_date': value['card_expiration_date'] == null ? undefined : ((value['card_expiration_date']).toISOString().substring(0,10)),
        'card_last4': value['card_last4'],
        'card_token': value['card_token'],
        'card_type': value['card_type'],
        'account_description': value['account_description'],
        'account_number': value['account_number'],
        'account_routing_transit_number': value['account_routing_transit_number'],
        'account_category': value['account_category'],
        'account_number_last4': value['account_number_last4'],
        'account_number_length': value['account_number_length'],
        'account_id': value['account_id'],
    };
}

